import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Issue } from '../../issues/components/issue';
import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { Activities as ActivitiesOld } from './activities-old';
import { ActivityFilters } from './activityFilters';
import { ActivityFoldOneColumn } from './activityFoldOneColumn';

export const Activities = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  if (isCropCircleEnabled) {
    return <ActivitiesBase />;
  }

  return <ActivitiesOld />;
};

const ActivitiesBase = () => {
  const navigate = useNavigate();
  const { issueId } = useParams();
  const windowDimensions = useWindowDimensions();
  const maxHeight = (windowDimensions?.height ?? 0) - 220; // substract banner + padding height

  const onIssueSelected = useCallback(
    (issueId: string) => {
      navigate(`/activities/${issueId}`);
    },
    [navigate]
  );

  const handleDataLoaded = useCallback(
    (data: any[]) => {
      if (data?.length > 0 && !issueId) {
        onIssueSelected(data[0].id);
      }
    },
    [issueId, onIssueSelected]
  );

  const leftColumn = {
    title: 'activity.menu.title',
    mainComponent: (
      <ActivityFoldOneColumn
        onIssueSelected={onIssueSelected}
        showAssetName={true}
        selectedIssue={issueId}
        maxHeight={maxHeight}
        onDataLoaded={handleDataLoaded}
        hideFilterBar={true}
      />
    ),
    headerComponent: <ActivityFilters />,
  };

  const rightColumn = {
    title: 'activities.detail.title',
    showHeader: false,
    disableScroll: true,
    mainComponent: <Issue isComingFromActivities />,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
